import * as React from 'react';
import { Icon } from '@/components';
import { genBlock } from '@/utils/bem'
import './style.less';

interface WxBannerProps {
  img: string;
  className?: string;
  btnText: string;
  style?: React.CSSProperties;
  btnStyle?: React.CSSProperties;
  btnClick?: (() => void) | string;
}

const block = genBlock('wx-banner')

/**
 * @example
  img: string;
  btnText: string;
  style: React.CSSProperties;
  btnStyle: React.CSSProperties;
  btnClick?: (() => void) | string;
 */
export const WxBanner: React.FC<WxBannerProps> = ({
  img,
  className='',
  btnText,
  style={},
  btnStyle={},
  btnClick = () => null,
}) => {

  const handleClick = () => {
    if (typeof btnClick === 'function') {
      btnClick()
    }
    if (typeof btnClick === 'string') {
      window.location.href = btnClick
    }
  }

  return (
    <div className={`${block()} ${className}`} style={style}>
      <img src={img} alt="" className={block('img')} />
      <button className={block('btn')} onClick={handleClick} style={btnStyle}>
        {btnText}
        <Icon name="you" className={block('btn-icon')} />
      </button>
    </div>
  )
}